import React, { useRef, useState, useEffect } from "react";
import { Row, Col, Form, Input, Button, Modal, Checkbox } from "antd";
import { Link } from 'react-router-dom'
import LoginRules from './index.validation';
import LoginSide from "../../assets/images/login.svg";
import logoSmall from "../../assets/images/aparajithalogo.png";
import { UserLogin, GetLoginCredentialsForRememberMe } from '../../redux/Login/LoginActions';
import store from '../../redux/store';
import * as actions from "../../redux/Login/LoginTypes";
import { Redirect } from 'react-router-dom';
import { useSelector } from "react-redux";

export default function Login() {
  const [spinStatus, setSpinStatus] = useState(false);
  const [redirect, setRedirect] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const formRef = useRef();

  useEffect(async () => {
    if (localStorage.getItem("rememberme") == "true") {
      setRememberMe(true);
      var result = await GetLoginCredentialsForRememberMe({ userName: localStorage.getItem("user") });
      formRef.current?.setFieldsValue({ "userName": localStorage.getItem("user"), "password": result?.password });
    }
    else {
      setRememberMe(false);
    }

    const auth = localStorage.getItem("authenticated");
    if (auth) {
      setRedirect(true);
    }
  }, [1])

  const handleLogin = async () => {
    var userName = formRef.current.getFieldValue("userName");
    var password = formRef.current.getFieldValue("password");

    if (userName && password) {
      var userData = { userName: userName, password: password };
      store.dispatch({ type: actions.LOGIN, payload: userData });
      setSpinStatus(true);
      var result = await UserLogin(userData);
      setSpinStatus(false);
      if (result.msg != "success") {
        Modal.error({ content: result.msg });
      }
      else {
        setRedirect(true);
      }
    }
  }

  useEffect(() => {
    return () => {
      setSpinStatus(false);
    }
  }, [])

  const handleRememberMeChange = (e) => {
    setRememberMe(e.target.checked);
    localStorage.setItem("rememberme", e.target.checked);
  }

  if (redirect) {
    return (
      <Redirect to="/expenseclaim" />
    )
  }

  return (
    <Row gutter={[32, 0]} className="hp-authentication-page">

      <Col lg={12} span={24} className="hp-py-sm-0 hp-py-md-64">
        <Row className="hp-h-100" align="middle" justify="center">

          <Col
            xxl={11}
            xl={15}
            lg={20}
            md={20}
            sm={24}
            className="hp-px-sm-8 hp-pt-24 hp-pb-48 hp-text-center"
          >

            <img src={logoSmall} alt="Logo" width="180" class="hp-mb-24 " />
            <h2 className="hp-mb-sm-0 hp-text-color-primary-1 hp-text-color-dark-0 hp-text-center">Expense Application</h2>
            <p className="hp-mt-sm-0 hp-mt-8 hp-text-color-black-60 hp-text-center">Very good works are  waiting for you 🤞</p>

            <Form
              ref={formRef}
              layout="vertical"
              name="basic"
              initialValues={{ remember: true }}
              className="hp-mt-sm-16 hp-mt-32"
              onFinish={handleLogin}
            >
              <Form.Item name="userName" label="Username :" className="hp-mb-16" rules={LoginRules.userName}>
                <Input />
              </Form.Item>
              <Form.Item name={"password"} label="Password :" className="hp-mb-32" rules={LoginRules.password}>
                <Input.Password />
              </Form.Item>
              <Row gutter={32} justify="space-between" className="hp-mb-16">
                <Col>
                  <Checkbox onChange={handleRememberMeChange} checked={rememberMe}>Remember Me</Checkbox>
                </Col>
                <Col>
                  <Link to="/forgotpassword">Forgot Password?</Link>
                </Col>
              </Row>
              <Button htmlType="submit" block type="primary" loading={spinStatus}>
                Sign in
              </Button>
            </Form>
          </Col>
        </Row>
      </Col>

      <Col lg={12} span={24} className="hp-bg-color-primary-4 hp-bg-color-dark-90 hp-position-relative">
        <Row className="hp-image-row hp-h-100 hp-px-sm-8 hp-px-md-16 hp-pb-sm-32 hp-pt-md-96 hp-pt-md-32">
          <Col span={24}>
            <Row align="middle" justify="center" className="hp-h-100">
              <Col md={20} span={24} className="hp-bg-item hp-text-center hp-mb-md-32">
                <img src={LoginSide} alt="Logo" width="900" className=" hp-position-relative" style={{ zIndex: "999" }} />
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};